import { render, staticRenderFns } from "./AddToTransferBasketDialog.vue?vue&type=template&id=6a1a46cf&scoped=true&"
import script from "./AddToTransferBasketDialog.vue?vue&type=script&lang=js&"
export * from "./AddToTransferBasketDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddToTransferBasketDialog.vue?vue&type=style&index=0&id=6a1a46cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a46cf",
  null
  
)

export default component.exports